import {
	Dispatch,
	SetStateAction,
	memo,
	useCallback,
	useEffect,
	useState,
} from "react";
import FilterComponent from "../../../components/common/FilterComponent";
import { getCPWaterFallFilter } from "../../../queries/ScenarioForecast";
import useFilter from "../../../hooks/useFilter";
import FilterComponentCreator from "../../../components/common/FilterComponent/FilterComponentCreator";
import { PriceMarginWaterfallFilterConfig } from "./PriceMarginWaterfallFilterConfig";

type Props = {
	handleWaterfallFilterValueChange: Dispatch<
		SetStateAction<WaterFallFilterSelectedValues>
	>;
	handelBaseFilterValueChange: Dispatch<
		SetStateAction<BaseCustomerPortabilityFilterValues>
	>;
	setLoading: Dispatch<SetStateAction<number>>;
	waterfallSelectedFilterValues: WaterFallFilterSelectedValues;
	baseFilterValues: BaseCustomerPortabilityFilterValues;
};

const dateRangeDropdownList: SelectDropDown[] = [
	{ label: "Jan 2024 - Dec 2024", value: "Jan 2024 - Dec 2024" },
];

const PriceMarginWaterfallFilter = ({
	handleWaterfallFilterValueChange,
	setLoading,
	waterfallSelectedFilterValues,
}: Props) => {
	const [filterResponse, setFilterResponse] = useState();
	const { selectedFilter } = useFilter();
	useEffect(() => {
		fnGetCustomerList(waterfallSelectedFilterValues);
	}, []);

	const fnGetCustomerList = async (waterfallSelectedFilterValues: WaterFallFilterSelectedValues) => {
		setLoading((prev) => prev + 1);
		try {
			const res = await getCPWaterFallFilter(
				{
					...waterfallSelectedFilterValues,
					customer: waterfallSelectedFilterValues.customer || undefined
				},
				selectedFilter
			);
			setFilterResponse(res.data.data);
		} catch (err) {
			console.log("Error while fetching getCPWaterFallFilter: ", err);
		} finally {
			setLoading((prev) => prev - 1);
		}
	};

	const handleFilterValueChange = (
		key: string,
		value: string | string[]
	) => {
		debugger;
		handleWaterfallFilterValueChange((prev) => ({ ...prev, [key]: value }));
		fnGetCustomerList(waterfallSelectedFilterValues)

	};

	return (
		<>
			{selectedFilter == "electrical" &&
				<FilterComponent
					type="single"
					filterName="Date Range"
					options={dateRangeDropdownList}
					labelKey="label"
					valueKey="value"
					loading={false}
					placeholder={"select"}
					value={[dateRangeDropdownList[0].value]}
					cleanable={false}
				/>
			}
			<FilterComponentCreator config={PriceMarginWaterfallFilterConfig[selectedFilter]} data={filterResponse}
				handleFilterValueChange={handleFilterValueChange}
				values={{ ...waterfallSelectedFilterValues }} />
		</>
	);
};

export default memo(PriceMarginWaterfallFilter);
